import apiSlice from "../../app/api/apiSlice";

export const companionAppApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAdminCompanionAppConfig: builder.query({
			query: () => `/api/admin/companion-app/config`,
			providesTags: [{ type: "AppSettings", id: "COMPANION_APP_CONFIG" }],
		}),
		updateAdminCompanionAppConfig: builder.mutation({
			query: ({ config }) => ({
				url: `/api/admin/companion-app/config`,
				method: "PUT",
				body: { config },
			}),
			invalidatesTags: [{ type: "AppSettings", id: "COMPANION_APP_CONFIG" }],
		}),
	}),
	overrideExisting: true,
});

export const {
	useGetAdminCompanionAppConfigQuery,
	useUpdateAdminCompanionAppConfigMutation,
} = companionAppApiSlice;
